// extracted by mini-css-extract-plugin
module.exports = {"text":"CountdownComponent_text__Vk5rQ"};